export const playStoreURL = window.env.PLAY_STORE_URL;
export const appStoreURL = window.env.APP_STORE_URL;
export const logoURL = `${process.env.PUBLIC_URL}${window.env.LOGO_PATH}`;
export const baseUrl = window.env.API_URL;

const urls = {
  theme: `Theme`,
  kpi: `KPI`,
  perspective: `Perspective`,
  pillar: `Pillar`,
  strategyMap: `StrategyMap`,
  objective: `Objective`,
  strategicObjective: `StrategicObjective`,
  strategicSubObjective: `StrategicSubObjective`,
  user: `User`,
  notification: `Notification`,
  login: `Login`,
  handshake: `Handshake`,
  workflow: `Workflow`,
  request: `Request`,
  orgStructure: `OrgStructure`,
  comment: `KPI/KPIComment`,
  group: `Group`,
  kpiTypeConfiguration: `KPITypeConfiguration`,
  kpiType: `kpiType`,
  delegation: `Delegation`,
  attachment: `Attachment`,
  centralAdmin: `CentralAdministration`,
  sysPerf: `SystemPerformanceThreshold`,
  weight: `Weight`,
  notificationConf: `NotificationConfiguration`,
  taskCenter: `TaskCenter`,
  strategy: `Strategy`,
  pplus: `PPlus`,
  initiative: "Initiative",
  kpiDashboard: "KPIDashboard",
  dashboard: "Dashboard",
  program: "Program",
  baseUrl,
};

export default urls;
